<template>
    <b-container class="p-0 rw-complete-story2">
        <b-row>
            <b-col cols="12" class="mb-2" v-if="qdata.image">
                <div class="question-item__image">
                    <img class="mw-100" :src="imageSrc(qdata.image.data.src)" alt="">
                </div>
            </b-col>
            <b-col cols="12" v-if="qdata.label2">
                <div class="text-start ql-editor" style="font-size: 22px;" v-if="qdata.label2" v-html="qdata.label2.data.value"></div>
            </b-col>
        </b-row>
        <div class="question-example mt-4" style="font-size: 1.3rem;">
            <p class="text-start section-title mb-0"><strong>Examples</strong></p>
            <div class="example__block border p-2 rounded text-start" v-if="!qdata.example">
                <p>1. Betty couldn’t wear her new skirt to school because she <b-form-input disabled class="input-custom" value="dropped her cereal"/> on it.</p>
                <p class="m-0">2. When the students first saw their new teacher they <b-form-input disabled class="input-custom" value="looked surprised"/>.</p>
            </div>
            <div class="example__block border p-2 rounded text-start" v-if="qdata.example">
                <b-row>
                    <b-col cols="12" v-for="(item, index) in qdata.example" :key="index" class="mb-3">
                        <div class="d-flex align-items-center">{{ index + 1}}. <component :is="dynamicComponent(item.question_text.data.value, item.answer)" /></div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-row v-if="qdata.questions" class="mt-4" style="font-size: 1.3rem;">
            <p class="text-start section-title mb-0"><strong>Questions</strong></p>
            <b-col cols="12" v-for="(item, index) in qdata.questions" :key="index" class="mb-3">
                <div class="d-flex align-items-center">{{ index + 1}}. <TextInput2 class="mw-100" v-model="result[index]" :content="item.question_text.data.value"/></div>
                <!-- <p>{{ index + 1}}. {{ item.question_text.data.value }}</p> -->
            </b-col>
            <!-- <button @click="test">Toet</button> -->
        </b-row>
    </b-container>
</template>

<script>

import TextInput2 from './components/TextInput2.vue'
import {
    // BRow,
    // BCol,
    // BCard,
    // BModal,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_complete_story2',
    data () {
        return {
            imageDefault: require('@/assets/img-default.jpg'),
            result: []
        }
    },
    components: {
        // BRow,
        // BCol,
        // BCard,
        // BModal,
        TextInput2,
        BContainer,
    },
    props: {
        qdata: Object
    },
    created() {
        for (let index = 0; index < this.qdata.questions.length; index++) {
            this.result[index] = null
        }
    },
    methods: {
        parseContent(content, value) {
            value = value[0] || ''
            if (value) {
                value = value.answer_text.data.value
            }

            const regex = /\$\$/gi
            let result
            const indices = [];
            while ((result = regex.exec(content))) {
                indices.push(result.index);
            }
            for (let index = indices.length - 1; index >= 0; index--) {
                content = `${content.substr(0, indices[index])}<b-form-input class="input-custom" disabled value="${value}" type="text" autocomplete="false" />${content.substr(indices[index] + 2, content.length)}`
            }

            return content
        },
        dynamicComponent(text, answer) {
             return {
                template: `<div class="text_answer text-start mx-1">${this.parseContent(text, answer)}</div>`,
             }
        },
        test () {
            console.log(this.result)
        },
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    },
    watch: {
        result () {
            this.$emit('input', {
                answers: this.result
            })
            // console.log(this.result)
        }
    }
}
</script>


<style scoped>

.example__block input {
    max-width: 100%;
}
</style>